var map = {
	"./black/qiangcha.png": "rDhs",
	"./blue/qiangcha.png": "nmU9",
	"./white/qiangcha.png": "c9Ik"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JhvP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/qiangcha\.png$
// module id = JhvP
// module chunks = 24